import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@p/Home/index.vue'),
  },
  {
    path: '/message',
    name: 'message',
    component: () =>
      import(/* webpackChunkName: "message-page" */ '@p/Message/index.vue'),
  },
  {
    path: '/result/:preTransNo?/:accessCode?/:terminalType?',
    name: 'result',
    component: () =>
      import(/* webpackChunkName: "result" */ '@p/Result/index.vue'),
  },
  {
    path: '/:country/n/:preTransNo/:terminalType?',
    name: 'dynamicCallbackPage',
    component: () =>
      import(/* webpackChunkName: "result" */ '@p/Result/index.vue'),
  },
  {
    path: '/m',
    name: 'staticCallbackPage',
    component: () =>
      import(/* webpackChunkName: "result" */ '@p/Result/index.vue'),
  },
  {
    path: '/auth/vk/callback',
    name: 'VKCallback',
    component: () => import('@p/Callback/VKCallback.vue'),
    meta: {
      skipAuth: true, // 免token验证
    },
  },
  {
    path: '/external-browser',
    name: 'externalBrowser',
    component: () => import('@p/Callback/ExternalBrowser.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
